import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Base from "components/Base";
import { useToastContext } from "components/alert/ToastContext";
import ExecucaoPlano from "components/qualidade/ExecucaoPlano";
import Produto from "model/administracao/cadastro/produto/Produto";
import ApontamentoOP from "model/producao/ApontamentoOP";
import ComponenteOP from "model/producao/ComponenteOP";
import EstagioOP from "model/producao/EstagioOP";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { TabPanel, TabView } from "primereact/tabview";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ApontamentoOpService from "service/producao/ApontamentoService";
import { produtoCompleteMethod, produtoItemTemplate } from "utils/autocompleteUtils";
import { generateKey } from "utils/generateKey";
import SelecaoLotesModal from "./SelecaoLotesModal";
import { Dialog } from "primereact/dialog";
import { useLoadingContext } from "provider/LoadingProvider";
import { Checkbox } from "primereact/checkbox";
import { Label } from "components/input/Label";

const apontamentoOpService = new ApontamentoOpService();

export default function EstagioApontamentoCadastro() {

    const [queryParameters] = useSearchParams();

    const [estagioOp, setEstagioOp] = useState<EstagioOP>(new EstagioOP());
    const [titulo, setTitulo] = useState<string>('Apontamento');
    const [editarLote, setEditarLote] = useState<{ visible: boolean, componenteOP: ComponenteOP, rowIndex: number }>({ visible: false, componenteOP: new ComponenteOP(), rowIndex: -1 });
    const [editarLoteAcerto, setEditarLoteAcerto] = useState<{ visible: boolean, componenteOP: ComponenteOP, rowIndex: number }>({ visible: false, componenteOP: new ComponenteOP(), rowIndex: -1 });
    const [visibleDialogQuantidadeFinal, setVisibleDialogQuantidadeFinal] = useState(false);
    const [qtProduzida, setQtProduzida] = useState<number | null>(0);
    const [reprovado, setReprovado] = useState(false);

    const [produtos, setProdutos] = useState<Produto[]>([]);
    const [produtosFiltrados, setProdustosFiltrados] = useState<Produto[]>([]);

    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    const { startLoading, stopLoading } = useLoadingContext();

    useEffect(() => {
        const idEstagioOp = parseInt(window.location.pathname.substring(`/apontamentoOp/apontar/`.length))

        apontamentoOpService.consultarEstagio(idEstagioOp).then(data => {
            setEstagioOp(data);
            buscarMateriasPrimas();
        }).catch(error => {
            console.error(error);
            if (error.data.message) {
                console.error(error.data.message);
            }
        });
    }, []);

    function buscarMateriasPrimas() {
        apontamentoOpService.materiasPrimas().then(data => {
            setProdutos(data);
        }).catch(err => {
            console.log(err);
        })
    }

    function validar() {
        return true;
    }

    function handleFinalizar() {

        if (!podeFinalizar()) {
            return;
        }
        if (estagioOp.estagioFinal) {
            apontamentoOpService.opTemReprovacao(estagioOp.ordemProducao.id).then(data => {
                setReprovado(data);
                setQtProduzida(estagioOp.ordemProducao.qtPrevista);
                setVisibleDialogQuantidadeFinal(true);
            }).catch(error => {
                console.error(error);
                if (error.data.message) {
                    console.error(error.data.message);
                }
            });
        } else {
            finalizar();
        }
    }

    function finalizar() {
        startLoading();
        let apontamentoOp = new ApontamentoOP();
        apontamentoOp.estagioOP = estagioOp;
        apontamentoOp.tipo = "FIM"
        apontamentoOp.qtProduzida = qtProduzida || 0;
        apontamentoOp.reprovado = reprovado;
        apontamentoOpService.apontar(apontamentoOp).then(data => {
            stopLoading();
            setVisibleDialogQuantidadeFinal(false);
            msgSucesso("Sucesso", "Apontamento finalizado com sucesso");
        }).catch(error => {
            stopLoading();
            console.error(error);
            if (error.data.message) {
                msgAlerta("Alerta", error.data.message);
                console.error(error.data.message);
            }
        });
    }

    function podeFinalizar() {
        for (let i = 0; estagioOp.componentes.length > i; i++) {
            if (estagioOp.componentes[i].qtUtilizada == 0) {
                msgAlerta("Alerta", "Quantidade utilizada zero no componente " + estagioOp.componentes[i].sequencial);
                return false;
            }
            const lotes = estagioOp.componentes[i].lotes;
            let qtdTotal = 0;
            for (let j = 0; lotes.length > j; j++) {
                if (lotes[j].qtUtilizada <= 0) {
                    msgAlerta("Alerta", "Quantidade inválida para o lote " + lotes[j].estoqueLote.lote + " no componente" + estagioOp.componentes[i].sequencial);
                    return false;

                }
                qtdTotal = ((qtdTotal * 100000000) + (lotes[j].qtUtilizada * 100000000)) / 100000000;
            }

            if (qtdTotal != estagioOp.componentes[i].qtUtilizada) {
                msgAlerta("Alerta", "Quantidade total dos lotes diferente da quantidade do utilizada no componente " + estagioOp.componentes[i].sequencial);
                return false;
            }
        }

        if (!componentesValidos(estagioOp.componentes) || !componentesValidos(estagioOp.componentesAcerto)) {
            return false;
        }


        return true;
    }

    function componentesValidos(componentes: ComponenteOP[]) {
        for (let i = 0; componentes.length > i; i++) {
            if (!componentes[i].componente || !componentes[i].componente?.codigo) {
                msgAlerta("Alerta", "Componente não informado no item " + componentes[i].sequencial);
                return false;
            }
            if (componentes[i].qtUtilizada == 0) {
                msgAlerta("Alerta", "Quantidade utilizada zero no componente " + componentes[i].sequencial);
                return false;
            }
            const lotes = componentes[i].lotes;
            let qtdTotal = 0;
            for (let j = 0; lotes.length > j; j++) {
                if (lotes[j].qtUtilizada <= 0) {
                    msgAlerta("Alerta", "Quantidade inválida para o lote " + lotes[j].estoqueLote.lote + " no componente" + componentes[i].sequencial);
                    return false;

                }
                qtdTotal = ((qtdTotal * 100000000) + (lotes[j].qtUtilizada * 100000000)) / 100000000;
            }

            if (qtdTotal != componentes[i].qtUtilizada) {
                msgAlerta("Alerta", "Quantidade total dos lotes diferente da quantidade do utilizada no componente " + componentes[i].sequencial);
                return false;
            }
        }
        return true
    }

    function bodyQuantidade(rowData: ComponenteOP, options: any) {
        return (
            <InputNumber value={rowData.qtUtilizada}
                inputStyle={{ width: '100%' }}
                style={{ width: '100%' }}
                minFractionDigits={isKgouLt(rowData.componente?.unidadeMedida || "") ? 1 : 0}
                maxFractionDigits={isKgouLt(rowData.componente?.unidadeMedida || "") ? 8 : 0}
                maxLength={12}
                locale="pt-BR"
                useGrouping={false}
                onChange={(e) => {
                    const comps = [...estagioOp.componentes];
                    comps[options.rowIndex].qtUtilizada = e.value as number;
                    setEstagioOp({ ...estagioOp, componentes: comps });
                }}
            />
        )
    }

    function bodyQuantidadeAcerto(rowData: ComponenteOP, options: any) {
        return (
            <InputNumber value={rowData.qtUtilizada}
                inputStyle={{ width: '100%' }}
                style={{ width: '100%' }}
                minFractionDigits={isKgouLt(rowData.componente?.unidadeMedida || "") ? 1 : 0}
                maxFractionDigits={isKgouLt(rowData.componente?.unidadeMedida || "") ? 8 : 0}
                maxLength={12}
                locale="pt-BR"
                useGrouping={false}
                onChange={(e) => {
                    const comps = [...estagioOp.componentesAcerto];
                    comps[options.rowIndex].qtUtilizada = e.value as number;
                    setEstagioOp({ ...estagioOp, componentesAcerto: comps });
                }}
            />
        )
    }

    function bodyComponenteAcerto(rowData: ComponenteOP, options: any) {

        return (
            <AutoComplete
                value={rowData.componente}
                placeholder="Selecione um Componente"
                style={{ width: '100%' }}
                inputStyle={{ width: "100%" }}
                field="nome"
                itemTemplate={(item: Produto) => produtoItemTemplate(item)}
                suggestions={produtosFiltrados}
                completeMethod={(e) => {
                    let filtered = produtoCompleteMethod(produtos, e.query);
                    setProdustosFiltrados(filtered);
                }}
                onChange={(e) => {
                    let estagioOpLocal = JSON.parse(JSON.stringify(estagioOp));
                    if (typeof e.target.value == "string") {
                        let prod = new Produto();
                        prod.nome = e.target.value;
                        estagioOpLocal.componentesAcerto[options.rowIndex].componente = prod;
                    } else {
                        estagioOpLocal.componentesAcerto[options.rowIndex].componente = e.target.value;
                    }
                    rowData['componente'] = estagioOpLocal.componentesAcerto[options.rowIndex].componente;

                    setEstagioOp(estagioOpLocal);
                }}

            />
        )
    }

    const isKgouLt = (unidadeMedida: string) => {
        return unidadeMedida == "KG" || unidadeMedida == "LT";
    }

    function novoAcerto(): void {
        let acerto = new ComponenteOP();
        acerto.acerto = 'S';
        acerto.sequencial = (estagioOp.componentesAcerto?.length + 1) || 1
        acerto.key = generateKey();
        acerto.componente = new Produto()

        estagioOp.componentesAcerto.push(acerto)
        setEstagioOp({ ...estagioOp })
    }

    return (

        <Base tituloPagina={'Apontamento'}>
            {editarLote.visible && <SelecaoLotesModal
                visible={editarLote.visible}
                setVisible={(visible) => { setEditarLote({ visible: visible, componenteOP: new ComponenteOP(), rowIndex: -1 }) }}
                produto={editarLote.componenteOP.componente || new Produto()}
                quantidade={editarLote.componenteOP.qtUtilizada > 0 ?
                    editarLote.componenteOP.qtUtilizada
                    :
                    editarLote.componenteOP.qtPrevista
                }
                lotes={editarLote.componenteOP.lotes}
                onConfirm={(lotes) => {

                    editarLote.componenteOP.lotes = lotes;
                    const comps = [...estagioOp.componentes];
                    comps[editarLote.rowIndex] = editarLote.componenteOP;

                    if (lotes.length > 0 && editarLote.componenteOP.qtUtilizada == 0) {
                        let qtdTotal = 0;
                        lotes.forEach(lote => {
                            qtdTotal = ((qtdTotal * 100000000) + (lote.qtUtilizada * 100000000)) / 100000000;
                        })
                        comps[editarLote.rowIndex].qtUtilizada = qtdTotal;
                    }

                    setEstagioOp({ ...estagioOp, componentes: comps });
                    setEditarLote({ visible: false, componenteOP: new ComponenteOP(), rowIndex: -1 })
                }}
            />}

            {editarLoteAcerto.visible && <SelecaoLotesModal
                visible={editarLoteAcerto.visible}
                setVisible={(visible) => { setEditarLoteAcerto({ visible: visible, componenteOP: new ComponenteOP(), rowIndex: -1 }) }}
                produto={editarLoteAcerto.componenteOP.componente || new Produto()}
                quantidade={editarLoteAcerto.componenteOP.qtUtilizada > 0 ?
                    editarLoteAcerto.componenteOP.qtUtilizada
                    :
                    editarLoteAcerto.componenteOP.qtPrevista
                }
                lotes={editarLoteAcerto.componenteOP.lotes}
                onConfirm={(lotes) => {
                    editarLoteAcerto.componenteOP.lotes = lotes;
                    const comps = [...estagioOp.componentesAcerto];
                    comps[editarLoteAcerto.rowIndex] = editarLoteAcerto.componenteOP;

                    setEstagioOp({ ...estagioOp, componentesAcerto: comps });
                    setEditarLoteAcerto({ visible: false, componenteOP: new ComponenteOP(), rowIndex: -1 })
                }}
            />}

            {visibleDialogQuantidadeFinal && <Dialog visible={visibleDialogQuantidadeFinal}
                style={{ width: '30%' }} onHide={() => setVisibleDialogQuantidadeFinal(false)}
                header="Quantidade Final" footer={<div>
                    <Button label="Finalizar" icon="pi pi-check" onClick={() => finalizar()} />
                    <Button label="Cancelar" icon="pi pi-times" onClick={() => setVisibleDialogQuantidadeFinal(false)} />
                </div>} >
                <div>
                    <Checkbox checked={reprovado} onChange={(e) => setReprovado(e.checked as boolean)} style={{ marginRight: 8 }} />
                    <Label>Reprovar?</Label>
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <label style={{ fontWeight: "bold" }}>Quantidade Final</label>
                    <InputNumber value={qtProduzida}
                        inputStyle={{ width: '100%' }}
                        style={{ width: '100%' }}
                        minFractionDigits={isKgouLt(estagioOp.ordemProducao.produto.unidadeMedida) ? 1 : 0}
                        maxFractionDigits={isKgouLt(estagioOp.ordemProducao.produto.unidadeMedida) ? 8 : 0}
                        maxLength={12}
                        locale="pt-BR"
                        useGrouping={false}
                        onChange={(e) => {
                            setQtProduzida(e.value as number);
                        }}
                    />
                </div>
            </Dialog>}


            <TabView>
                <TabPanel header="Dados Gerais">
                    <div className="row" style={{ marginBottom: 10 }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ fontWeight: "bold" }}>Ordem de Produção</label>
                            <InputText style={{ width: "30%" }} value={estagioOp.ordemProducao?.numero + ""} readOnly />
                        </div>
                    </div>

                    <div className="row" style={{ marginBottom: 10 }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label className="col col-sm-12" style={{ fontWeight: "bold" }}>Produto</label>
                            <div className="col-sm-12">
                                <InputText required value={estagioOp.ordemProducao?.produto.codigo || ""} readOnly style={{ width: '20%', marginRight: 10 }} />
                                <InputText required value={estagioOp.ordemProducao?.produto.nome} readOnly style={{ width: '50%' }} />
                            </div>
                        </div>

                    </div>

                    <div className="row" style={{ marginBottom: 10 }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ fontWeight: "bold" }}>Estágio</label>
                            <InputText style={{ width: "30%" }} value={estagioOp.estagio?.nome} readOnly />
                        </div>
                    </div>

                    {estagioOp.ordemProducao.itemPedido ? <div style={{ marginBottom: 10, display: "flex", width: "30%", justifyContent: "space-between" }}>
                        <div style={{ display: "flex", flexDirection: "column", width: "48%" }}>
                            <label style={{ fontWeight: "bold" }}>Pedido</label>
                            <InputText style={{ width: "100%" }} value={estagioOp.ordemProducao.itemPedido?.pedido?.numeroPedido + ""} readOnly />
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", width: "48%" }}>
                            <label style={{ fontWeight: "bold" }}>Item</label>
                            <InputText style={{ width: "100%" }} value={estagioOp.ordemProducao.itemPedido?.sequencial + ""} readOnly />
                        </div>
                    </div> : null}
                </TabPanel>
                {estagioOp.componentes?.length > 0 ?
                    <TabPanel header="componentes">
                        <DataTable value={estagioOp.componentes} emptyMessage="Nenhum registro encontrado">
                            <Column field="sequencial" header="Sequencial" />
                            <Column field="componente.codigo" header="Código" />
                            <Column field="componente.nome" header="Componente" />
                            <Column field="qtPrevista" header="Qtd. Prevista" body={rowData => rowData.qtPrevista + " " + rowData.componente?.unidadeMedida || ""} />
                            <Column field="qtUtilizada" header="Qtd. Utilizada" body={bodyQuantidade} style={{ width: 150 }} />
                            <Column header="Lotes" style={{ width: 150 }} body={(rowData: ComponenteOP, options) => {
                                return (
                                    <Button label="Selecionar" onClick={() => { setEditarLote({ visible: true, componenteOP: rowData, rowIndex: options.rowIndex }) }} />
                                )
                            }} />
                        </DataTable>
                    </TabPanel>

                    : null}

                {estagioOp.execucaoPlanoQualidade?.id ?
                    <TabPanel header="Plano de Qualidade">
                        <ExecucaoPlano
                            value={estagioOp.execucaoPlanoQualidade}
                            onChange={(value) => { setEstagioOp({ ...estagioOp, execucaoPlanoQualidade: value }) }}
                            editable={true}
                        />
                    </TabPanel>
                    : null}
                {estagioOp.temAcerto == "S" ?
                    <TabPanel header="Acerto">
                        <DataTable value={estagioOp.componentesAcerto} emptyMessage="Nenhum registro encontrado"
                            header={<div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div></div>
                                <span style={{ textAlign: 'center', alignSelf: "center" }}>Componentes</span>
                                <Button
                                    style={{}}
                                    type="button" icon={<FontAwesomeIcon icon="add" />}
                                    className="ui-button-info"
                                    onClick={() => novoAcerto()}
                                ></Button>
                            </div>}
                        >
                            <Column field="sequencial" header="Sequencial" style={{ width: 100 }} />
                            <Column field="componente.codigo" header="Código" />
                            <Column field="componente.nome" header="Componente" body={bodyComponenteAcerto} />
                            <Column field="qtUtilizada" header="Qtd. Utilizada" body={bodyQuantidadeAcerto} style={{ width: 150 }} />
                            <Column header="Lotes" style={{ width: 150 }} body={(rowData: ComponenteOP, options) => {
                                return (
                                    <Button label="Selecionar" onClick={() => { setEditarLoteAcerto({ visible: true, componenteOP: rowData, rowIndex: options.rowIndex }) }} />
                                )
                            }} />
                        </DataTable>
                    </TabPanel>
                    : null}
            </TabView>

            <div style={{ display: "flex", justifyContent: "end", marginTop: 10 }}>
                <Button label="Finalizar" onClick={() => { handleFinalizar() }} />
            </div>

        </Base>
    )
}
